export default __webpack_public_path__ + "static/media/default_case_cover.3121d1d2.png";